export const DRAFT_DATA_COOKIE_NAME = "next_drupal_draft_data"

// See https://vercel.com/docs/workflow-collaboration/draft-mode
export const DRAFT_MODE_COOKIE_NAME = "__prerender_bypass"
